import React from 'react'
import {useSelector} from 'react-redux'
import {seoTypeSelector} from '../selectors'

/** @param {import('./SeoText').SeoTextProps} props */
export default function SeoText(props) {
    const {className, tag = 'div', type} = props

    const text = useSelector((state) => seoTypeSelector(state, type))

    return (
        text &&
        React.createElement(tag, {
            className,
            dangerouslySetInnerHTML: {__html: text.trim()},
        })
    )
}
